import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["className", "items", "cancelText", "close", "title", "subTitle", "needBottomOffset"];
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { cls, componentWrapper } from '@arco-design/mobile-utils';
import { ContextLayout } from '../context-provider';
import Popup from '../popup';
import { open } from './methods';
var ActionSheet = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      items = props.items,
      cancelText = props.cancelText,
      close = props.close,
      title = props.title,
      subTitle = props.subTitle,
      _props$needBottomOffs = props.needBottomOffset,
      needBottomOffset = _props$needBottomOffs === void 0 ? true : _props$needBottomOffs,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var popupRef = useRef(null);
  useImperativeHandle(ref, function () {
    return popupRef.current;
  });

  function handleItemClick(e, item) {
    e.stopPropagation();

    if (item.status === 'disabled') {
      return;
    }

    var result = item.onClick ? item.onClick(e) : null;

    if (!result || typeof result === 'boolean') {
      !result && (close == null ? void 0 : close(e));
    } else if (result && result.then) {
      result.then(function (res) {
        return !res && (close == null ? void 0 : close(e));
      });
    }
  }

  return /*#__PURE__*/React.createElement(ContextLayout, null, function (_ref) {
    var prefixCls = _ref.prefixCls;
    return /*#__PURE__*/React.createElement(Popup, _extends({
      ref: popupRef,
      className: cls(prefixCls + "-action-sheet", className),
      contentClass: prefixCls + "-action-sheet-content",
      close: close,
      direction: "bottom",
      needBottomOffset: needBottomOffset
    }, otherProps), title || subTitle ? /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-action-sheet-header"
    }, title ? /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-action-sheet-title"
    }, title) : null, subTitle ? /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-action-sheet-sub-title"
    }, subTitle) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-action-sheet-list"
    }, (items || []).map(function (item, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: cls(prefixCls + "-action-sheet-item", item.className, item.status || 'normal'),
        key: index,
        style: item.style,
        onClick: function onClick(e) {
          return handleItemClick(e, item);
        }
      }, item.content);
    })), cancelText ? /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-action-sheet-item cancel-item",
      onClick: function onClick(e) {
        e.stopPropagation();
        close == null ? void 0 : close(e);
      }
    }, cancelText) : null);
  });
});
export function methodsGenerator(Comp) {
  return {
    /**
     * 打开动作面板
     * @param {ActionSheetProps} config 配置
     * @returns {{ close: () => void; update: (newConfig: ActionSheetProps) => void; }}
     */
    open: open(Comp)
  };
}
/**
 * 动作面板组件
 * @type 反馈
 * @name 动作面板
 */

export default componentWrapper(ActionSheet, methodsGenerator(ActionSheet));